import Vue from "vue";
import Vuex from "vuex";

import entities from './modules/entities';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    entities,
  },
});
